export default __webpack_public_path__ + "apply8_1a129a7.png";